import { Popover } from "antd";
import classNames from "classnames";
import React from "react";
import ActiveIcon from "../assets/active-benifit-icon.svg";
import DisactiveIcon from "../assets/disactive-benifit-icon.svg";
import DescIcon from "./assets/desc-icon.svg";

interface BenefitItemProps {
  label: React.ReactNode;
  active: boolean;
  is365Unlimited?: boolean;
  desc?: string;
}

export const BenefitItem: React.FC<BenefitItemProps> = ({
  label,
  active,
  is365Unlimited,
  desc,
}) => {
  return (
    <div className="flex items-center w-full">
      <div className="flex items-center justify-center w-4 h-4 shrink-0 mr-1">
        {active ? (
          <ActiveIcon className="block" width={16} height={16} />
        ) : (
          <DisactiveIcon className="block" width={13} height={13} />
        )}
      </div>

      <span
        className={classNames(
          "text-sm font-normal leading-5 whitespace-nowrap",
          active ? "text-white" : "text-white/40",
        )}
      >
        {label}
      </span>

      {desc && (
        <Popover
          trigger={["hover"]}
          placement="bottomLeft"
          arrow={false}
          classNames={{
            root: "!pr-0 !pt-0",
            body: classNames(
              "!p-2 !px-4 flex bg-[#32303F]! text-white/80 text-sm! text-center !rounded-lg",
            ),
          }}
          content={<>{desc}</>}
        >
          <DescIcon className="ml-2" />
        </Popover>
      )}

      {is365Unlimited && (
        <div className="flex items-center flex-grow min-w-0">
          <div
            className="flex-grow h-px ml-2 mr-3"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgba(255, 255, 255, 0.3) 2px, transparent 2px)",
              backgroundSize: "4px 1px",
              backgroundRepeat: "repeat-x",
            }}
          />
          <div
            className="text-black px-1 py-px rounded-[6px] text-[11px] font-bold whitespace-nowrap shrink-0"
            style={{
              background:
                "linear-gradient(93deg, #C2C9FF 0.37%, #7E8AF3 97.13%)",
            }}
          >
            365 UNLIMITED
          </div>
        </div>
      )}
    </div>
  );
};

export default BenefitItem;
